/* eslint-disable max-len */
export default {
    one: {
        section: {
            title: 'Wie profitieren Sie von <strong>der Partnerschaft</strong> mit Lemlock?'
        },
        button: 'Erfahren Sie mehr über Lemlock',
        icons: [{
            align: 'right',
            title: 'Experten dreier branchen',
            title_2_lines: 'Experten dreier<br/> branchen',
            desc: 'Lemlock ist eine Synergie, die die Kompetenz von Sicherheitstestern, Anwälten und Software-Ingenieuren vereint.'
        }, {
            align: 'right',
            title: 'Überwachung und verifikation',
            title_2_lines: 'Überwachung und<br/> verifikation',
            desc: 'Lemlocks Team überwacht die Einführung von Veränderungen an Ihrer Infrastruktur, Software oder Informationssystemen. Nach der durchgeführten Verifikation können Sie sicher sein, dass vorgenommene Korrekturen oder Verbesserungen mit der Dokumentation/dem Bericht über den Sicherheitsstatus in rechtlicher und technischer Hinsicht kompatibel sind.'
        }, {
            align: 'right',
            title: 'Methodik und kompetenzen',
            title_2_lines: 'Methodik <br> und kompetenzen',
            desc: 'Lemlocks Tests und Prüfungen werden gemäß Richtlinien der OWASP und NIST durchgeführt und entsprechen den Standards der ISO 27000. Die Tester besitzen Zertifikate des polnischen Inlandsgeheimdienstes, die die Glaubwürdigkeit bestätigen und die Anwaltskanzlei überwacht den gesamten Prozess.'
        }, {
            align: 'right',
            title: 'Aktive überwachung',
            title_2_lines: 'Aktive<br> überwachung',
            desc: 'Die Kontinuität der Datensicherheit, unabhängig von neuen Bedrohungen, erfordert eine ständige, aktive Überwachung. Lemlock ist wie ein Alarm, der Sie über jede erkannte Bedrohung informiert.'
        }, {
            align: 'left',
            title: 'Start in 48 stunden',
            title_2_lines: 'Start in<br/> 48 stunden',
            desc: 'Das Starten des Testprozesses ist in weniger als zwei Tagen möglich. Die Garantie für einen schnellen Start und  die Transparenz über Arbeitsfortschritte ermöglicht Ihnen die Kontrolle über den gesamten Prozess.'
        }, {
            align: 'left',
            title: 'Sicherheitszertifikate',
            title_2_lines: 'Sicherheitszertifikate',
            desc: 'Lemlock Standard, Lemlock Platin und das DSGVO-Konformitätszertifikat werden Ihnen helfen, Ihre Glaubwürdigkeit und Ihr Vertrauen bei Kunden, Geschäftspartnern und Angestellten zu erhöhen.'
        }]
    },
    two: {
        section: {
            title: 'Wie wir arbeiten?'
        },
        icons: [
            'anfrage',
            'beratung',
            'monitoring',
            'bericht',
            'aufsicht',
            'zertifikat'
        ],
        bonus: '<span>BONUS:</span> Kostenlose Beratung mit einem Experten zur Implementierung und Modifikation von Schutzmaßnahmen.'
    },
    three: {
        button: 'Sichern Sie Ihre Anwendungen und digitalen Ressourcen',
        section: {
            title: 'Wie beweisen Sie,<br/> dass Sie Ihre Daten <strong>gut sichern</strong>?',
            desc: '<p>Ein moderner Kunde ist sich seiner Rechte in Bezug auf den Schutz personenbezogener Daten mehr und mehr bewusst. Unternehmen und Institutionen, die Daten sammeln oder verarbeiten, gewinnen einen großen Vorteil, wenn sie beweisen, dass sie das Thema Sicherheit ernst nehmen.</p><p>Indem Sie Lemlocks Lösungen verwenden, können Sie Ihren Kunden, Geschäftspartnern und Mitarbeitern ganz einfach mitteilen, dass Sie angemessene Sicherheitsvorkehrungen getroffen haben.</p>'
        },
        boxes: [{
            title: 'Lemlock STANDARD',
            textTop: 'penetrationstest<br/> sicherheitsaudit',
            textBottom: 'überprüfung des Sicherheitsniveaus und Entfernung entdeckter Lücken'
        }, {
            title: 'Lemlock PLATINIUM',
            textTop: 'netzwerk- und<br/> Serverüberwachung',
            textBottom: 'permanente Überwachung und sofortige Korrektur auftretender Schwachstellen'
        }, {
            title: 'DSGVO-Konformitätszertifikat',
            textTop: 'DSGVO-Konformitätsaudit',
            textBottom: 'implementiert Veränderungen gemäß den DSGVO-Richtlinien'
        }]
    },
    general: {
        cybersecurity_title: 'Cybersicherheit von Software und Anwendungen',
        consulting_title: 'Rechtliche und technische Beratung',
        read_more: 'Lesen Sie mehr',
        back: 'Zurück',
        button1: 'Mehr erfahren',
        button2: 'Lassen Sie sich kostenlos beraten'
    },
    clients: {
        title: 'Vertraut von'
    },
    list: [{
        slug: 'application-security-audits-penetration-tests',
        title: 'Sicherheitsaudits und Penetrationstests',
        subtitle: 'Informieren Sie sich über Fehler in Ihren Systemen, Webanwendungen und serverseitigen Anwendungen',
        icon: 'icon01',
        content: {
            title: 'Sicherheitsaudits und Penetrationstests',
            subtitle: 'zur Erkennung der Schwachstellen von Anwendungen und IT-Systemen',
            text: [
                'Durchführung kontrollierter Angriffe auf Ihre Anwendungen und IT-Systeme. Solche simulierten Hackerangriffe sind eine großartige Möglichkeit zur Überprüfung der Datensicherheit.',
                'Im Gegensatz zu einem echten Angriff werden Penetrationstests und Audits verwendet, um sowohl deutliche als auch kaum wahrnehmbare Unregelmäßigkeiten aufzuzeigen. Der Hauptzweck besteht in erster Linie darin, einen gründlichen Suchprozess nach Schwachstellen durchzuführen, der sich nicht nur auf die zuerst in Erscheinung getretene Schwachstelle konzentriert.',
                'Das Team von Lemlock kann, basierend auf dem generierten Bericht, identifizierte Schwachstellen (Art, Komplexität und Gewicht) überwachen. Anhand der Beschreibung werden notwendige Korrekturen oder Verbesserungen an Ihren IT-Systemen und Anwendungen durchgeführt.'
            ],
            icons_title: 'Die Audits basieren auf den Standards der <b>OWASP</b> und <b>OWASP Mobile</b> und sind angepasst an den Schutz Ihrer:',
            icons: [{
                icon: 'web',
                title: 'Webanwendungen'
            }, {
                icon: 'server',
                title: 'Server-/Cloud-Anwendungen'
            }, {
                icon: 'important',
                title: 'Mobilen Anwendungen'
            }]
        },
        cta: [{
            text: 'Fordern Sie einen Kostenvoranschlag an',
            icon: 'get',
            page: 'estimation'
        }, {
            text: 'Laden Sie unsere Broschüre herunter',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/de/Security_Audits_and_Penetration_Tests.pdf`
        }, {
            text: 'Fragen Sie uns nach Einzelheiten',
            icon: 'ask',
            page: 'contact'
        }]
    }, {
        slug: 'application-gdpr-compliant-audits',
        title: 'DSGVO-Konformitätsprüfung',
        subtitle: 'Finden Sie heraus, ob Ihre webbasierten, mobilen und serverseitigen Anwendungen die technischen und rechtlichen Anforderungen der neuen EU-Verordnung erfüllen',
        icon: 'icon02',
        content: {
            title: 'DSGVO-Konformitätsprüfung',
            subtitle: 'damit Ihre Anwendung dem neuen EU-Datenschutzgesetz entspricht',
            icons_title: 'Detaillierte Konformitätsprüfung für Ihre:',
            icons: [{
                icon: 'web',
                title: 'Webanwendungen'
            }, {
                icon: 'server',
                title: 'Server-/Cloud-Anwendungen'
            }, {
                icon: 'important',
                title: 'Mobilen Anwendungen'
            }],
            list_numbered_title: 'Unter Berücksichtigung dreier Perspektiven:',
            list_numbered: [{
                title: 'Die rechtliche Perspektive',
                text: 'Rechtsanwälte, die auf die IT-Branche spezialisiert sind, identifizieren personenbezogene Daten, bewerten das mit ihrer Verarbeitung verbundene Risiko basierend auf der <b">ISO 27000</b> und analysieren gegebenenfalls die Nutzungsbedingungen der Dienstleistungen im Rahmen der Anwendung.'
            }, {
                title: 'Die Ingenieursperspektive',
                text: 'Systemarchitekten und Softwareingenieure analysieren die Anwendungsarchitektur anhand des Quellcodes, um festzustellen, ob die Regeln der DSGVO eingehalten werden. Falls nicht, liefern sie entsprechende Empfehlungen.'
            }, {
                title: 'Die Cyber-Sicherheitsperspektive',
                text: 'Sicherheitsexperten verifizieren, ob personenbezogene Daten und alle Mechanismen, die im Rahmen der DSGVO geschaffen wurden, ordnungsgemäß gesichert sind.'
            }],
            list_numbered_text: 'Lemlocks Experten sind in der Lage, die Implementierung empfohlener Schutzmechanismen und notwendiger gesetzlicher Änderungen zu überwachen, um so das Risiko einer Datenverletzung oder eines Datenverlusts zu reduzieren.'
        },
        cta: [{
            text: 'Fordern Sie einen Kostenvoranschlag an',
            icon: 'get',
            page: 'estimation'
        }, {
            text: 'Laden Sie unsere Broschüre herunter',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/de/Audit_of_applications_compliance_with_the_GDPR.pdf`
        }, {
            text: 'Fragen Sie uns nach Einzelheiten',
            icon: 'ask',
            page: 'contact'
        }]
    }, {
        slug: 'continuous-pentesting',
        title: 'Continuous Pentesting & DSGVO',
        subtitle: 'Jede Änderung der Anwendung mit fortlaufende Kontrolle der Cybersicherheit',
        icon: 'icon03',
        content: {
            title: 'Continuous Pentesting & DSGVO',
            subtitle: 'Erweitern Sie Ihr System um neue Funktionen mit kontinuierlicher Überprüfung der Cybersicherheit und Einhaltung der DSGVO\n',
            text: [
                'Ihr Unternehmen, sowie Ihre IT Lösungen entwickeln sich ständig weiter. Um Ihr Produkt für einen sich ständig ändernden Markt attraktiv zu machen, müssen Sie neue Funktionen hinzufügen. Zum Zeitpunkt einer Systemänderung besteht jedoch das Risiko einer neuen Sicherheitslücke oder der Nichteinhaltung der DSGVO. Natürlich können Sie vor der Veröffentlichung der neuen Version der Anwendung eine Sicherheitsüberprüfung, <span class="offer-details-blue">oder die DSGVO-Konformitätsprüfung anordnen</span>, dies kann jedoch zeitaufwändig und teuer sein. Berücksichtigen Sie stattdessen den Continuous Pentesting und DSGVO-Dienst.',
                'Dank Continuous Pentesting & DSGVO wird Ihre Lösung durch einen Prozess abgedeckt, der folgendes umfasst:',
                [
                    'aktuelle Sicherheitsüberprüfungen,',
                    'aktuelle technische Inspektionen der DSGVO,',
                    'Sicherheitsberatung für Ihr Entwicklerteam,',
                    'schnelle Benachrichtigungen über festgestellte Verstöße und Schwachstellen,',
                    'sofortige Korrektur von Sicherheitsmaßnahmen,',
                    'laufende Überwachung der Schwachstellen der von Ihnen verwendeten Open Source-Bibliotheken,',
                    'Integritätsüberprüfung Ihrer Systemproduktionsumgebung.'
                ],
                'Die Sicherheit von Daten und Anwendungen ist ein kontinuierlicher Prozess. Daher lohnt es sich, die Sicherheit des Continuous Delivery-Prozesses zusammen mit dem Lemlock-Sicherheitsteam zu gewährleisten. Dies hilft Ihnen nicht nur die Sicherheitsprobleme schneller zu lösen, sondern verringert auch die Anzahl neuer Sicherheitslücken, da das Entwicklerteam einen Sicherheitsexperten an der Seite hat.',
                'Darüber hinaus kann die Integrität der Produktionsumgebung ständig überwacht werden, um festzustellen, ob die Anwendung geändert wurde (geändertes Bankkonto, Inhaltsänderungen, unsichtbare bösartige Software, die Mitarbeiter und Client-Computer infizieren), und so Finanzielle- und Ruf-Verluste vermeiden.'
            ]
        },
        cta: [{
            text: 'Fordern Sie einen Kostenvoranschlag an',
            icon: 'get',
            page: 'estimation'
        }, {
            text: 'Laden Sie unsere Broschüre herunter',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/de/Application_Security_Monitoring.pdf`
        }, {
            text: 'Fragen Sie uns nach Einzelheiten',
            icon: 'ask',
            page: 'contact'
        }]
    }, {
        slug: 'risk-management-security-policy',
        title: 'Risiko- und Sicherheitspolitik-Management',
        subtitle: 'Passen Sie die Sicherheitsrichtlinien Ihres Unternehmens an das Risiko von IT-Ressourcen an',
        icon: 'icon04',
        content: {
            title: 'Risiko- und Sicherheitspolitik-Management',
            subtitle: 'um das Risiko Ihrer digitalen Ressourcen zu bewerten und angemessene Mittel zu ihrer Verwaltung bereitzustellen',
            text: [
                'Überprüfen Sie, welche Arten von Daten im Rahmen Ihrer digitalen Ressourcen (Server, Datenbanken, Anwendungen) in Ihrem Unternehmen verarbeitet werden. Gewinnen Sie Kenntnisse über die Maßnahmen, die ergriffen werden müssen, um Ressourcen angemessen zu sichern, unabhängig davon, ob sie in Bezug stehen zu:',
                [
                    'persönliche Daten (DSGVO),',
                    'Know-how, Vorschriften und Geschäftsgeheimnis,',
                    'Lohn- oder Gehaltsabrechnung.'
                ],
                'Dieser Prozess wird in Übereinstimmung mit der <span class="offer-details-blue">ISO 2700x, DSGVO</span> und anderen anwendbaren gesetzlichen Bestimmungen durchgeführt.',
                'Lemlocks Experten können die Umsetzung empfohlener Änderungen der Risikomanagementstrategie und der Sicherheitsrichtlinien überwachen und das Unternehmen dabei unterstützen, das Bewusstsein für diese Probleme zu schärfen.'
            ]
        },
        cta: [{
            text: 'ordern Sie einen Kostenvoranschlag an',
            icon: 'get',
            page: 'estimation',
            hash: 'decrease'
        }, {
            text: 'Laden Sie unsere Broschüre herunter',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/de/Risk_management_and_security_policy.pdf`
        }, {
            text: 'Fragen Sie uns nach Einzelheiten',
            icon: 'ask',
            page: 'contact'
        }]
    }, {
        slug: 'incident-handling-and-post-breach-analysis',
        title: 'Störungsmanagement und Analyse nach einem Angriff',
        subtitle: 'Stellen Sie sicher, dass Sie im Fall eines Angriffs auf Ihre IT-Ressourcen von einem Partner unterstützt werden, der angemessene rechtliche und technische Verfahren einleitet',
        icon: 'icon05',
        content: {
            title: 'Störungsmanagement und Analyse nach einem Angriff',
            subtitle: 'um Sie im Falle eines Cyberangriffs zu unterstützen',
            text: [
                'Vorfälle im Zusammenhang mit der Verletzung der Datensicherheit erfordern eine schnelle und gut durchdachte Reaktion, einschließlich einer Reihe von <span class="offer-details-blue">rechtlichen und technischen</span> Aktivitäten, wie:',
                [
                    'Bestätigung des Vorfalls und seine Unterbrechung,',
                    'Sicherung des Systems und Bestimmung der Angriffsskala,',
                    'Sammeln von Beweisen,',
                    'Inkenntnissetzung der interessierten Parteien, u.a. Polizei, der Inspektor personenbezogener Daten, CERT (Computer Emergency Response Team) und CSIRT (Computer Security Incident Response Team)'
                ],
                'In Zeiten von Cyber-Bedrohungen lohnt es sich, jemanden zu haben, auf den man sich immer verlassen kann.'
            ]
        },
        cta: [{
            text: 'Handeln Sie sofort, wenn Sie Opfer eines Cyberangriffs sind!',
            icon: 'act',
            pdf_lp: 'https://www.lemlock.de/verfahren-bei-cyberangriffen/'
        }, {
            text: 'Laden Sie unsere Broschüre herunter',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/de/Incident_handling_and_post_breach_analysis.pdf`
        }]
    }, {
        slug: 'staff-training',
        title: 'Schulung des Personals',
        subtitle: 'Bereiten Sie das Personal in Ihrem Unternehmen darauf vor, gemäß den Sicherheitsvorschriften sowohl im rechtlichen als auch im technischen Kontext zu arbeiten',
        icon: 'icon06',
        content: {
            title: 'Schulung des Personals',
            subtitle: 'um sicherzustellen, dass die Mitarbeiter ihre Aufgaben gemäß den Sicherheitsstandards erfüllen und in einer kritischen Situation entsprechend reagieren',
            text: [
                'Um sicherzustellen, dass Ihr Unternehmen die Sicherheitsregeln und -gesetze (einschließlich der DSGVO) vollständig einhält, werden spezielle <span class="offer-details-blue">Schulungen für Mitarbeiter</span> durchgeführt.'
            ],
            list_numbered_title: 'Laut Lemlocks Experten sollten Personen mit folgenden Posten obligatorisch am Training teilnehmen:',
            list_numbered: [{
                icon: 'network',
                title: 'Netzwerkadministratoren',
                text: 'Damit sie wissen, wie man Netzwerke verwaltet und sie unter Berücksichtigung der Sicherheitsaspekte konfiguriert.'
            }, {
                icon: 'database',
                title: 'Entwickler und Datenbankadministratoren',
                text: 'Damit sie verantwortungsvoll arbeiten und Anwendungen, Systeme und Datenbanken bei der Erstellung, Aktualisierung oder dem täglichen Management mit einem hohen Schutzniveau ausstatten.'
            }, {
                icon: 'nonTech',
                title: 'Nichttechnisches Personal',
                text: 'Damit alle Mitarbeiter sich der Verfahren, Werkzeuge und Richtlinien bewusst sind, die das Risiko der Infiltration eines Unternehmens verringern.'
            }],
            bottom_text: [
                'Dank der durchgeführten Schulungen werden Mitarbeiter der oben genannten Posten Sicherheitsregeln bewusst einhalten und Aufgaben so ausführen, dass das Unternehmen vor materiellen / immateriellen Schäden geschützt wird.'
            ]
        },
        cta: [{
            text: 'Laden Sie unsere Broschüre herunter',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/de/Staff_training.pdf`
        }, {
            text: 'Fragen Sie uns nach Einzelheiten',
            icon: 'ask',
            page: 'contact'
        }]
    }]
};



// WEBPACK FOOTER //
// ./src/i18n/de/offer.js